import { COUNCIL_REPORT_MANIFEST } from '@fixtyer/content';

/**
 * Backwards-compatible authority-name lookup generated from the content
 * manifest. Aliases cover existing API/database spellings only.
 */
export const councilPages: Record<string, string> = Object.fromEntries(
  COUNCIL_REPORT_MANIFEST.flatMap((entry) => {
    if (!entry.reportUrl) return [];
    const reportUrl = entry.reportUrl;
    const names = [
      entry.canonicalName,
      entry.displayName,
      entry.entity?.name,
      entry.entity?.areaName,
    ].filter((name): name is string => Boolean(name));
    return names.map((name) => [name, reportUrl]);
  })
);

Object.assign(councilPages, {
  'Brighton & Hove': '/councils/brighton-and-hove',
  'Dudley Council': '/councils/dudley',
  'Worcestershire County Council': '/councils/worcestershire',
});

const displayNames = new Map(
  COUNCIL_REPORT_MANIFEST.map((entry) => [entry.canonicalName, entry.displayName])
);

export function getCouncilDisplayName(name: string): string {
  return displayNames.get(name) ?? name;
}
